import React from 'react';
import { Route } from 'react-router';
import { Switch } from 'react-router-dom';

import { Cart } from 'components/Cart/Cart';
import { Checkout, ALL_CHECKOUT_PATHS } from 'components/Checkout/Checkout';
import { NotFoundPage } from 'components/ErrorPage/NotFoundPage';
import { redesignV2RoutePath } from 'constants/redesignV2';
import { useReseller } from 'hooks/Reseller/useReseller';
import { Environment } from 'utils/Environment';
import { safeExternalRedirect } from 'utils/SafeRedirect';
import { PagesSwitch } from './PagesSwitch/PagesSwitch';
import { PartnerBump } from 'components/PartnerBump/PartnerBump';

export const MAIN_LEAD_GEN_FORM = '/contact/request-a-call';
export const REQUEST_A_DEMO_PATH = '/contact/request-a-demo';
export const CONNECT_TO_SALES_PATH = 'https://connect.clover.com/get-started';
export const DASHBOARD_LOGIN_LINK = '/dashboard/login';
export const DEPRECATED_CONNECT_TO_SALES_PATH = '/contact/connect-to-sales';

export const Routes: React.FC<{ children?: never }> = () => {
  const { referralId, isDemoAvailable, resellerRedirectUrl } = useReseller();
  const { protocol, hostname } = window.location;

  const externalBankContactLink = Environment.getExternalBankContactLink(referralId);

  if (resellerRedirectUrl) {
    safeExternalRedirect(resellerRedirectUrl);
  }

  return (
    <Switch>
      <Route path="/partner/:partnerName" render={() => <PartnerBump />} />
      <Route path={Object.values(ALL_CHECKOUT_PATHS)} exact component={Checkout} />
      <Route path={redesignV2RoutePath.CART} component={Cart} />

      {externalBankContactLink && (
        <Route
          exact
          path={[MAIN_LEAD_GEN_FORM, REQUEST_A_DEMO_PATH, DEPRECATED_CONNECT_TO_SALES_PATH]}
          render={() => {
            safeExternalRedirect(externalBankContactLink);
            return null;
          }}
        />
      )}

      {!isDemoAvailable && (
        <Route
          exact
          path={REQUEST_A_DEMO_PATH}
          render={() => {
            safeExternalRedirect(`${protocol}//${hostname}${MAIN_LEAD_GEN_FORM}`);
            return null;
          }}
        />
      )}

      <Route
        render={() => (
          <PagesSwitch>
            <Route render={() => <NotFoundPage />} />
          </PagesSwitch>
        )}
      />
    </Switch>
  );
};
